import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'twoDigitDecimal'
})
export class TwoDigitDecimalPipe implements PipeTransform {
  transform(value) {
    if (value != null && (value+"").length>0) {
      const rounded = Math.round(value * 100) / 100;
      if (rounded > 0) {
        let x = rounded.toFixed(2);

        x = x.toString();
        let afterPoint = '';
        if (x.indexOf('.') > 0) {
          afterPoint = x.substring(x.indexOf('.'), x.length);
        }

        const y = Math.floor(parseFloat(x)) + '';
        let lastThree = y.substring(y.length - 3);
        const otherNumbers = y.substring(0, y.length - 3);
        if (otherNumbers !== '') {
          lastThree = ',' + lastThree;
        }
        return (
          otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
          lastThree 
          + afterPoint
        );
      } else {
        return rounded.toFixed(2);
      }

      // return parseFloat(rounded.toFixed(1))
    } else {
      return "0.00";
    }
  }
}
